<template>
  <el-dropdown v-if="options && options.length" @command="runCommand" trigger="click" class="merge-field-dropdown">
    <span class="el-dropdown-link font-semibold">{{ dropdownLabel }}<i class="el-icon-arrow-down" :class="{ 'mini-trigger': isMini }"></i> </span>
    <el-dropdown-menu slot="dropdown" class="merge-field-dropdown-menu" size="small">
      <!-- Option Groups -->
      <el-option-group v-for="option in options" :key="option.label" :label="option.label">
        <el-dropdown-item v-for="item in option.items" :key="item.value" :command="item" size="small">
          <ArrowIcon className="arrow" />
          <span class="text-xs mr-4">
            {{ item.label || item.value }}
          </span>
        </el-dropdown-item>
      </el-option-group>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import Vue from 'vue';
import ArrowIcon from '@/components/UI/ArrowIcon.vue';

export default Vue.extend({
  name: 'MergeFieldDropdown',
  components: {
    ArrowIcon,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    command: {
      type: Function,
      default: () => {
        // do nothing
      },
    },
    mode: {
      type: String,
      default: 'full',
    },
  },
  computed: {
    isMini() {
      return this.mode === 'mini';
    },
    dropdownLabel() {
      return this.isMini ? '' : 'Insert Variable';
    },
  },
  methods: {
    runCommand(data) {
      this.command(data);
    },
  },
});
</script>

<style>
.merge-field-dropdown {
  font-weight: 600;
}

.mini-trigger {
  padding: 9px;
}

.merge-field-dropdown .el-dropdown-link {
  color: #6d6156;
}

.email-editor-menu-bar .merge-field-dropdown .el-dropdown-link {
  color: #3c5ccf;
}

.merge-field-dropdown-menu .el-select-group__title {
  color: #6d6156;
  font-weight: 500;
}

.merge-field-dropdown-menu li {
}

.merge-field-dropdown-menu .el-select-group__wrap {
  padding: 0;
  &:not(:last-of-type) {
    padding: 0 0 15px 0;
    &::after {
      content: '';
      display: none;
    }
  }
}

/*
.merge-field-dropdown li {
  line-height: 40px;
}
*/

.merge-field-dropdown-menu .el-dropdown-menu__item {
  font-weight: 600;
  line-height: 42px;
}

li > .arrow {
  margin-top: -4px;
  margin-right: 8px;
  display: inline-block;
  color: #c3b2a1;
}

li:hover > .arrow {
  @apply text-brand-blue;
}
</style>
